import { signal } from "@preact/signals-react";

export const CatalogueDetailsIsEmpty = signal(false)
export const CatalogueDetailsPriceEvolutionFilters = signal({})
export const CatalogueDetailsStockEvolutionFilters = signal({})